<template>
    <DefaultField
        :field="currentField"
        :errors="errors"
        :show-help-text="showHelpText"
        :full-width-content="fullWidthContent"
    >
        <template #field>
            <div class="persian-time-field w-full">
                <date-picker
                    :class="errorClasses"
                    :clearable="true"
                    :color="color"
                    compact-time
                    :disabled="currentlyIsReadonly"
                    :format="format"
                    :id="currentField.uniqueKey"
                    :initial-value="fieldValue"
                    :input-attrs="{ style: 'direction: ltr; text-align: end;' }"
                    inputClass="w-full form-control form-input form-input-bordered"
                    :locale="locale"
                    :min="min"
                    :placeholder="placeholder"
                    type="time"
                    v-model="value"
                >
                </date-picker>
            </div>
        </template>
    </DefaultField>
</template>

<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import { DependentFormField, HandlesValidationErrors } from '@/mixins'
import jMoment from 'moment-jalaali'

export default {
    components: {
        DatePicker: Vue3PersianDatetimePicker,
    },

    mixins: [DependentFormField, HandlesValidationErrors],

    computed: {
        color() {
            return this.currentField.color || 'rgb(30, 136, 229)'
        },

        fieldValue() {
            return this.normalizedValue(this.currentField.value)
        },

        format() {
            return this.currentField.format || 'HH:mm'
        },

        locale() {
            return this.currentField.locale || 'fa,en'
        },

        placeholder() {
            if (this.currentlyIsReadonly && ! this.currentField.value) {
                return this.__('Select start time first')
            }

            return this.currentField.placeholder || '00:00'
        },

        min() {
            return this.currentField.min || null
        },
    },

    methods: {
        fill(formData) {
            this.fillIfVisible(formData, this.field.attribute, this.normalizedValue(this.value) || '')
        },

        normalizedValue(value) {
            if (! value) {
                return ''
            }

            const parsed = jMoment(value, ['HH:mm', 'HH:mm:ss', this.format], true)

            return parsed.isValid() ? parsed.format('HH:mm') : String(value).slice(0, 5)
        },

        setInitialValue() {
            this.value = this.fieldValue
        },
    },
}
</script>

<style>
.vpd-next svg,
.vpd-prev svg {
    display: inline;
}
</style>
